import {
  Grid,
  CardActionArea,
  Box,
  Stack,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControlLabel,
  RadioGroup,
  Radio,
  Divider,
} from "@mui/material";
import { dispatch, useSelector } from "src/redux/store";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/system";
import palette from "src/theme/palette";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AddIcon from "@mui/icons-material/Add";
import { editPaymentStatus } from "src/redux/slices/viabilityStudy/viabilityStudy";
import { useEffect, useState, useRef } from "react";
import {
  saveKMZstudy,
  editStudyUploadFile,
  editStudyDeleteFile,
} from "src/redux/slices/viabilityStudy/viabilityStudy";
import useAuth from "src/hooks/useAuth";
import ConfirmAlert from "src/components/ConfirmAlert";
import { deleteStudy, getAllStudies } from "src/redux/slices/dashboard/studies";
import firebase from "firebase/compat/app";
import { DataObjectOutlined, FileCopyOutlined, Public, Map } from "@mui/icons-material";
import JsonViewerFullScreenDialog from "./JsonViewerFullScreenDialog";
import AuxFilesFullScreenDialog from "./AuxFilesFullScreenDialog";
import { DocumentData } from "firebase/firestore";
import CrmAccordion from "./CrmAccordion";
import DataCollapse from "./DataCollapse";
import DataDirectorCollapse from "./DataDirectorCollapse";
import UserCollapse from "./UserCollapse";
import BudgetCollapses from "./BudgetCollapse";
import { LoadingButton } from "@mui/lab";
import { readFileAsync } from "src/utils/fileReader";
import axios from "axios";
import { HOST_API } from "src/config";
import { useSnackbar } from "notistack";

export default function StudiesCrmItem({ study }: any) {
  const db = firebase.firestore();
  const { user } = useAuth();
  const inputFile = useRef<any>(null);
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState<string>();
  const [fileRemove, setFileRemove] = useState();
  const [clienteInfo, setClienteInfo] = useState<DocumentData | null>(null);
  const [openFullScreenDialog, setOpenFullScreenDialog] = useState(false);
  const [openFullScreenDialogAuxFiles, setOpenFullScreenDialogAuxFiles] =
    useState(false);
  const [paymentStatus, setPaymentStatus] = useState(
    study.paymentStatus === "PENDING"
      ? "Pagamento pendente"
      : study.paymentStatus === "CANCELED"
      ? "Pagamento cancelado"
      : study.paymentStatus === "CONFIRMED"
      ? "Pagamento confirmado"
      : "Não criou pagamento"
  );
  const { isLoadingDelete } = useSelector((state) => state.studies);
  const [downloadingFiles, setDownloadingFiles] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const OPTIONS = [
    { value: "NONE", label: "Não criou pagamento" },
    { value: "PENDING", label: "Pagamento pendente" },
    { value: "CANCELED", label: "Pagamento cancelado" },
    { value: "CONFIRMED", label: "Pagamento confirmado" },
  ];

  const TagStyle = styled(Box)(() => ({
    padding: "6px 15px 6px 15px",
    backgroundColor: palette.light.grey[700],
    color: "white",
    borderRadius: "20px",
  }));

  const CardDownloadStyle = styled(Box)(() => ({
    width: "80px",
    cursor: "pointer",
    height: "80px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: palette.light.primary.main,
    color: "white",
    borderRadius: "12px",
  }));

  const CardUploadStyle = styled(Box)(() => ({
    width: "80px",
    cursor: "pointer",
    height: "80px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: palette.light.common.white,
    border: "2px solid " + palette.light.grey[400],
    color: palette.light.grey[600],
    borderRadius: "12px",
    position: "relative",
  }));

  const CardUploadAddStyle = styled(Box)(() => ({
    width: "80px",
    cursor: "pointer",
    height: "80px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: palette.light.common.white,
    border: "2px dotted " + palette.light.grey[400],
    color: palette.light.grey[500],
    borderRadius: "12px",
    position: "relative",
  }));

  const XButtonStyle = styled(Box)(() => ({
    position: "absolute",
    width: "20px",
    height: "20px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    top: "-6px",
    right: "-6px",
    backgroundColor: palette.light.grey[600],
    color: palette.light.common.white,
    borderRadius: "12px",
  }));

  const onClickViewData = () => {
    setOpenFullScreenDialog(true);
  };

  const onClickViewMap = () =>
    study.kmzFileLink && window.open(study.kmzFileLink);
  const onClickViewDxf = async () => {
    if (study?.dxfFileLink) {
      window.open(study.dxfFileLink);
    } else {
      try {
        const downloadDxfPayload = {
            kmzGoogleLink: study?.kmzFileLink,
            userId: study?.userId,
            studyId: study?.id
        };
        const responseWithLink = await axios.post(`${HOST_API}/files/downloadKmzAsDxf`, downloadDxfPayload);
        if(responseWithLink){
            window.open(responseWithLink?.data?.fileUrl);
            dispatch(getAllStudies());
        }else{
            enqueueSnackbar('Erro ao baixar arquivos, tente novamente mais tarde ou contate o suporte!', { variant: 'error' });
        }
      } catch (error) {
            enqueueSnackbar('Erro ao baixar arquivos, tente novamente mais tarde ou contate o suporte!', { variant: 'error' });
      }
    }
  };

  const onClickViewFiles = () => {
    setOpenFullScreenDialogAuxFiles(true);
  };

  const buscaInfoCliente = async () => {
    try {
      const userInfo = await db.collection("users").doc(study.userId).get();
      if (userInfo.data()) {
        setClienteInfo(userInfo.data() ?? null);
      } else {
        setClienteInfo(null);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const removeFile = async () => {
    await dispatch(editStudyDeleteFile(study, fileRemove));
    setFileRemove(undefined);
    setOpen(false);
  };

  const onChangeFile = async (e: any) => {
    const files = e.target.files ?? [];
    if (files.length > 0) {
      const fileContent = await readFileAsync(files[0]);
      const payload = {
        study_id: study.id,
        user_id: user?.uid,
        file_name: files[0].name,
        file: fileContent,
      };
      const fileUrl = await dispatch(saveKMZstudy(payload));
      await dispatch(editStudyUploadFile(study, fileUrl));
    }
  };

  const downloadAllFiles = async () => {
    if (study?.results && study.results.length > 0) {
      enqueueSnackbar("Compactando arquivos...", { variant: "info" });
      try {
        setDownloadingFiles(true);
        const response = await axios.post(
          `${HOST_API}/order/download-files`,
          { files: study.results },
          { responseType: "arraybuffer" }
        );
        const arrayBuffer = new Uint8Array(response.data).buffer;
        const blob = new Blob([arrayBuffer], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `arquivos.zip`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        enqueueSnackbar("Iniciando download dos arquivos...", {
          variant: "success",
        });
        setDownloadingFiles(false);
      } catch (error) {
        enqueueSnackbar("Erro ao baixar arquivos", { variant: "error" });
      }
    }
  };

  useEffect(() => {
    if (study) {
      setStatus(study.status ?? "finished");
      setPaymentStatus(
        study.paymentStatus === "PENDING"
          ? "Pagamento pendente"
          : study.paymentStatus === "CANCELED"
          ? "Pagamento cancelado"
          : study.paymentStatus === "CONFIRMED"
          ? "Pagamento confirmado"
          : "Não criou pagamento"
      );
      buscaInfoCliente();
    }
  }, [study]);

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Grid
          container
          direction={"row"}
          width={"100%"}
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
        >
          {/* <Grid item md={1}>
					<Chip
						sx={{ color: 'white'}}
						label={status === 'pending' ? 'Pendente' : 'Finalizado' }
						color={status === 'pending' ? 'warning' : 'success' }
					/>
				</Grid> */}
          <Grid item md={4}>
            <Typography>
              <b>{study.createdAt}</b>
              <br />
              {clienteInfo?.corporate}
            </Typography>
          </Grid>
          <Grid item md={4}>
            <Typography>
              <b>{study.userName}</b> - {study.name}
              <br />
              {clienteInfo?.cnpj}
            </Typography>
          </Grid>
          <Grid item md={3}>
            <TagStyle>
              <Typography>{paymentStatus}</Typography>
            </TagStyle>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container direction={"column"}>
          <Grid item flex={1}>
            <Typography variant="h6">Estudo</Typography>
            <Box mt={2} />
            <Divider />
            <Stack direction={"column"} spacing={2}>
              <CrmAccordion title="Mapa">
                <CardActionArea
                  sx={{ borderRadius: "12px" }}
                  onClick={onClickViewMap}
                >
                  <CardDownloadStyle>
                    <Map fontSize="large" />
                  </CardDownloadStyle>
                </CardActionArea>
              </CrmAccordion>
              {study?.selectedOptions?.downloadStudy &&
                study?.paymentStatus === "CONFIRMED" && (
                  <CrmAccordion title="Download do .dxf">
                    <CardActionArea
                      sx={{ borderRadius: "12px" }}
                      onClick={onClickViewDxf}
                    >
                      <CardDownloadStyle>
                        <Public fontSize="large" />
                      </CardDownloadStyle>
                    </CardActionArea>
                  </CrmAccordion>
                )}
              <CrmAccordion title="Dados">
                <Grid container direction={"row"} spacing={2}>
                  <Grid item xs={12}>
                    <Box>
                      <CardActionArea
                        sx={{ borderRadius: "12px" }}
                        onClick={onClickViewData}
                      >
                        <CardDownloadStyle>
                          <DataObjectOutlined fontSize="large" />
                        </CardDownloadStyle>
                      </CardActionArea>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <DataCollapse study={study} />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <DataDirectorCollapse study={study} />
                  </Grid>
                </Grid>
              </CrmAccordion>
              {study.selectedOptions ? (
                <CrmAccordion title="Serviços">
                  <Grid container direction={"row"} spacing={2}>
                    <Grid item xs={12}>
                      <BudgetCollapses study={study} />
                    </Grid>
                  </Grid>
                </CrmAccordion>
              ) : (
                <></>
              )}
              <CrmAccordion title="Cliente">
                <Grid container direction={"row"} spacing={2}>
                  <Grid item xs={12}>
                    <UserCollapse user={clienteInfo} />
                  </Grid>
                </Grid>
              </CrmAccordion>
              {study.dataHelper.otherFilesLink?.length > 0 ? (
                <CrmAccordion title="Arquivos">
                  <Grid container direction={"row"} spacing={2}>
                    <Grid item xs={12}>
                      <Box>
                        <CardActionArea
                          sx={{ borderRadius: "12px" }}
                          onClick={onClickViewFiles}
                        >
                          <CardDownloadStyle>
                            <FileCopyOutlined fontSize="large" />
                          </CardDownloadStyle>
                        </CardActionArea>
                      </Box>
                    </Grid>
                  </Grid>
                </CrmAccordion>
              ) : (
                <></>
              )}
            </Stack>
          </Grid>
          <Box mt={2} />
          <Divider />
          <Box mt={3} />
          <Grid item flex={1}>
            <Stack
              direction={"row"}
              spacing={2}
              justifyContent={"space-between"}
            >
              <Typography variant="h6">Resultado</Typography>
              {study.results && study.results?.length > 0 && (
                <Box>
                  <LoadingButton
                    loading={downloadingFiles}
                    variant="contained"
                    color="primary"
                    onClick={downloadAllFiles}
                    sx={{ textTransform: "none" }}
                  >
                    Baixar todos arquivos
                  </LoadingButton>
                </Box>
              )}
            </Stack>
            <Box mt={2} />
            <Stack direction={"row"} spacing={2}>
              {study.results?.map((doc: any) => (
                <Box>
                  <CardActionArea
                    sx={{ borderRadius: "12px" }}
                    onClick={() => window.open(doc.link)}
                  >
                    <CardUploadStyle>
                      <UploadFileIcon fontSize="large" />
                      <XButtonStyle
                        onClick={(e) => {
                          e.stopPropagation();
                          setFileRemove(doc);
                          setOpen(true);
                        }}
                      >
                        <Typography variant="overline">x</Typography>
                      </XButtonStyle>
                    </CardUploadStyle>
                  </CardActionArea>
                </Box>
              ))}
              {(!study.results || study.results?.length <= 9) && (
                <Box>
                  <CardActionArea
                    sx={{ borderRadius: "12px" }}
                    onClick={() => inputFile.current.click()}
                  >
                    <CardUploadAddStyle>
                      <AddIcon fontSize="large" />
                      <input
                        type="file"
                        hidden
                        id="file"
                        ref={inputFile}
                        onChange={onChangeFile}
                      />
                    </CardUploadAddStyle>
                  </CardActionArea>
                </Box>
              )}
            </Stack>
          </Grid>
        </Grid>
        <Box mt={2} />
        <RadioGroup
          row
          value={
            paymentStatus === "Pagamento pendente"
              ? "PENDING"
              : paymentStatus === "Pagamento cancelado"
              ? "CANCELED"
              : "NONE"
          }
          onChange={(_, v) => {
            dispatch(editPaymentStatus(study, v));
            setPaymentStatus(
              v === "PENDING"
                ? "Pagamento pendente"
                : v === "NONE"
                ? "Não criou pagamento"
                : v === "CANCELED"
                ? "Pagamento cancelado"
                : "Pagamento confirmado"
            );
          }}
        >
          {OPTIONS.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio />}
              label={option.label}
            />
          ))}
        </RadioGroup>
        <Box mt={3}>
          <LoadingButton
            loading={isLoadingDelete}
            variant="contained"
            color="error"
            onClick={() => deleteStudy(study.id, study.userId)}
          >
            Excluir
          </LoadingButton>
        </Box>
      </AccordionDetails>

      <ConfirmAlert
        open={open}
        setOpen={setOpen}
        title="Remover Documento"
        subtitle="Deseja remover este documento permanentemente?"
        callbackConfirm={removeFile}
        callbackDecline={() => {
          setOpen(false);
          setFileRemove(undefined);
        }}
      />
      <JsonViewerFullScreenDialog
        open={openFullScreenDialog}
        handleClose={() => setOpenFullScreenDialog(false)}
        json={study}
      />
      <AuxFilesFullScreenDialog
        open={openFullScreenDialogAuxFiles}
        handleClose={() => setOpenFullScreenDialogAuxFiles(false)}
        filesUrl={study.dataHelper.otherFilesLink ?? []}
      />
    </Accordion>
  );
}
